<nav id="PageMailHeader" class="navbar navbar-expand-md fixed-top header-toolbar "
    [ngClass]="{' fullBGImage ':isFullScreeen,' mobileBGImage ':!isFullScreeen}">
    <!-- Header_Left -->
    <div class="navbar-collapse collapse w-100 order-1 order-md-0 dual-collapse2 d-flex">
        <button *ngIf="menuToggleEnabled && showSideBar" class="menuBtn1 btn btn-default btn-sm p-0 mx-2" type="button"
            data-toggle="collapse" data-target="#name" aria-controls="name1" (click)="toggleMenu()">
            <span class="material-symbols-outlined">menu</span>
        </button>
        <button *ngIf="menuToggleEnabled && showSideBar" class="navbar-toggler menuBtn2" type="button"
            data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
            aria-expanded="false" aria-label="Toggle navigation">
            <span class="material-symbols-outlined">menu</span>
        </button>
        <div class="header-title d-none d-md-block" *ngIf="isLogoClickable">
            <a class="image-container" [ngStyle]="{'pointer-events':isHomeEnabled ? 'all' : 'none'}"
                [routerLink]="getAuthInfo[0].restrictEmpLogin ? ['/Offer-Acceptance'] : ['/ESS-Home']"
                *ngIf="getAuthInfo && getAuthInfo.length && getAuthInfo[0].isESS === 'ESS'">
                <img height="40px" [attr.src]="getIMG | safe:'resourceUrl'" class="img-responsive">
            </a>
            <a class="image-container" [ngStyle]="{'pointer-events':isHomeEnabled ? 'all' : 'none'}"
                [routerLink]="getAuthInfo[0].restrictEmpLogin ? ['/Offer-Acceptance'] : ['/home']"
                *ngIf="getAuthInfo && getAuthInfo.length && getAuthInfo[0].isESS !== 'ESS'">
                <img height="40px" [attr.src]="getIMG | safe:'resourceUrl'" class="img-responsive">
            </a>
        </div>
        <div class="header-title d-md-block" *ngIf="!isLogoClickable">
            <span class="image-container" [ngStyle]="{'pointer-events':isHomeEnabled ? 'all' : 'none'}"
                *ngIf="getAuthInfo && getAuthInfo.length && getAuthInfo[0].isESS === 'ESS'">
                <img height="40px" [attr.src]="getIMG | safe:'resourceUrl'" class="img-responsive">
            </span>
            <span class="image-container" [ngStyle]="{'pointer-events':isHomeEnabled ? 'all' : 'none'}"
                *ngIf="getAuthInfo && getAuthInfo.length && getAuthInfo[0].isESS !== 'ESS'">
                <img height="40px" [attr.src]="getIMG | safe:'resourceUrl'" class="img-responsive">
            </span>
        </div>
        <button *ngIf="getAuthInfo && getAuthInfo.length && getAuthInfo[0].customerName"
            class="user-button authorization ml-auto d-md-none border-0 bg-transparent" height="100%" stylingMode="text">
            <div class="d-flex align-items-center w-100">
                <app-user-panel [menuItems]="userMenuItems" menuMode="context" class="w-100"></app-user-panel>
            </div>
        </button>
    </div>

    <!-- Header_Center -->
    <div class="mx-auto order-0 d-none d-md-flex">
        <div class="header-title mx-auto text-nowrap"
            [ngStyle]="{'visibility':getAuthInfo && getAuthInfo.length && getAuthInfo[0].cid === 2026 ? 'hidden' : 'visible'}"
            *ngIf="getAuthInfo && getAuthInfo.length && getAuthInfo[0].customerName">{{getAuthInfo[0].customerName}}
        </div>
        <div class="header-title mx-auto text-nowrap"
            [ngStyle]="{'visibility':getAuthInfo && getAuthInfo.length && getAuthInfo[0].cid === 2026 ? 'hidden' : 'visible'}"
            *ngIf="getTitle && (!getAuthInfo || !getAuthInfo.length)">{{getTitle}}
        </div>
        <div class="header-title mx-auto text-nowrap"
            *ngIf="(!getAuthInfo || !getAuthInfo.length || !getAuthInfo[0].customerName) && !getTitle">
            <div class="image-container">
                <img height="60px" [attr.src]="getIMG1 | safe:'resourceUrl'" class="img-responsive">
            </div>
        </div>
    </div>

    <!-- Header_Right..
        1.Help..
        2.Notification..
        2.User_Menu..
    -->
    <div class="navbar-collapse collapse w-100 order-3 dual-collapse2 text-right d-none d-md-block">
        <!-- Help -->
        <div class="btn-group" *ngIf="showSideBar">
            <!-- <button class="btn helpBtn" routerLink="/help">
                <i class="fas fa-question-circle"></i>
            </button> -->
        </div>

        <!-- Notification -->
        <div class="btn-group ml-auto"
            *ngIf="getAuthInfo && getAuthInfo.length && getAuthInfo[0].customerName && notificationArr.length">
            <button class="noteBtn btn dropdown-toggle" title="Notifications" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-bell" id="notifications"> </i>
            </button>
            <div *ngIf="notificationArrLength"
                class="dropdown-menu dropdown-menu-right shadow-sm radius-10 cmenu notfication-panel">
                <ng-container *ngFor="let note of notificationArr">
                    <button *ngIf="note.readStatus==0" class="dropdown-item" type="button"
                        (click)="fnStatusUpdate(note)">
                        <span class="borderLeft d-flex align-items-center">{{note.message}}</span>
                    </button>
                </ng-container>
            </div>
            <div *ngIf="!notificationArrLength"
                class="dropdown-menu dropdown-menu-right shadow-sm radius-10 cmenu notfication-panel">
                <button class="dropdown-item" type="button" (click)="fnNavigateToNotification()">
                    <span class="borderLeft d-flex align-items-center">{{'View All Notifications'}}</span>
                </button>
            </div>
            <sup *ngIf="notificationArrLength"
                class="badge badge-primary badge-sm text-white mr-3 mb-4">{{notificationArrLength}}
            </sup>
        </div>

        <!-- User_Menu -->
        <button *ngIf="getAuthInfo && getAuthInfo.length && getAuthInfo[0].customerName"
            class="UserBtn user-button authorization border-0 bg-transparent"
            [ngClass]="{'ml-auto': !getAuthInfo || !getAuthInfo.length || !notificationArr.length}" height="100%"
            stylingMode="text">
            <div class="d-flex align-items-center w-100">
                <app-user-panel [menuItems]="userMenuItems" menuMode="context" class="w-100"></app-user-panel>
            </div>
        </button>
        <button *ngIf="menuToggleEnabled && showSideBar" class="navbar-toggler" type="button" data-toggle="collapse"
            data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
    </div>
</nav>